export class HideSlidesStorageService {
	constructor(storageKey) {
		this.storageKey = storageKey;
	}

	save(ids) {
		localStorage.setItem(this.storageKey, JSON.stringify(ids));
	}

	load() {
		const savedIds = localStorage.getItem(this.storageKey);
		if (!savedIds) {
			return [];
		}

		try {
			return JSON.parse(savedIds);
		} catch (error) {
			console.error('Error parsing saved selected slides IDs:', error);
			return [];
		}
	}
}